// libs
import { Record } from "immutable";
import moment from "moment";


const BaseRecord = Record({
  id: null, // string
  link: null, // string
  message: null, // string
  date: null // string
});

export default class NewsItem extends BaseRecord {
  init(data) {
    let message = data.message;
    message = message.replace(/[#＃][Ａ-Ｚａ-ｚA-Za-z一-鿆0-9０-９ぁ-ヶｦ-ﾟー]+/g, "");
    message = message.replace(/\u3000\u3000/g, "");
    message = message.trim();

    return this.withMutations(s =>
      s.set("id", data.id)
       .set("link", data.link)
       .set("message", message)
       .set("date", moment(data.updated_time).format("YYYY/MM/DD"))
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/models/NewsItem.js